import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const irrigationFlowRate: typeof valueTypeRenderers.irrigationFlowRate = {
  label: () => unitConverter.flowRate().titleWithoutUnit(),
  point: () => {
    const label = unitConverter.flowRate().title()

    return (value) => [
      {
        id: 'flowRateGpm',
        value: unitConverter.flowRate(value.flowRateGpm).valueAsString(),
        label,
      },
    ]
  },
}
